<div class="row" *lmsProfileGuard="'groups.group.surveys'">
  <div class="col s12">
    <h3 class="h3 chart-title margin-top-none">{{ 'groups.dashboard.surveys' | translate }}</h3>
  </div>

  <div class="row">
    <div class="col m3 s12">
      <lms-ratio-widget [ratio]="ratios?.ratioApplication" [data]="data" [key]="'ratioApplication'"></lms-ratio-widget>
    </div>

    <div class="col m3 s12">
      <lms-ratio-widget
        [ratio]="ratios?.ratioRecommendation"
        [data]="data"
        [key]="'ratioRecommendation'"
      ></lms-ratio-widget>
    </div>

    <div class="col m6 s12">
      <lms-nps-widget [ratio]="ratios?.ratioNPS" [data]="data" [key]="'nps'"></lms-nps-widget>
    </div>
  </div>
</div>
